﻿import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default function LoadingIndicator(props = null) {
  const loadingIndicator = {
    position: 'relative',
    color: 'black',
  };

  const loadingWrapper = {
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingTop: '2rem',
  };

  return (
    <div style={props.style == null ? loadingWrapper : props.style}>
      <CircularProgress style={loadingIndicator} />
    </div>
  );
}
